<template>
    <div class="order_list">
		<van-list v-if="total" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
			<base-card
				class="mt-28"
				v-for="item in list"
				:key="item.id"
				:title="`${item.productName}（${$status.detectType[item.detectType]}）`"
			>
				<van-button
					type="primary"
					block
					class="mt-28"
                    :disabled="item.status===0?true:false"
					@click="$utils.openPDF(item.reportUrl)"
				>查看报告 <van-icon name="arrow" /> </van-button>
			</base-card>
		</van-list>
		<base-empty v-else desc="暂无报告" :icon="0"></base-empty>
	</div>
</template>

<script>

export default {
    name:'ViewReport',
    data: () => ({
		loading: false,
		list: [],
		total: 0,
		page: 1,
		limit: 10
	}),

    computed: {
        finished () {
			return this.total <= this.list.length
		}
    },

    created() {
        this.getList()
    },

    methods: {
        async getList () {
            this.loading = true
            const res = await this.$api.order.detail(this.$route.params.orderId)
			if (!res.code) {
                this.list = res.data.detectOrderReportDTOList
                this.total = res.data.detectOrderReportDTOList.length
                this.loading = false
			}else{
                this.loading = false
            }
		},
    }
}

</script>

<style lang='css' scoped>
.order_list {
	padding: 18px 32px;
}
</style>